import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom'
import contentJson from './data/content.json'
import { supplementalPages } from './data/supplementalPages'
import type { SiteContent } from './types'
import { Header } from './components/Header'
import { Footer } from './components/Footer'
import { ScrollToTop } from './components/ScrollToTop'
import { HomePage } from './pages/HomePage'
import { ArticlePage, ContentPage, CouncilsArchivePage, NotFoundPage } from './pages/ContentPage'

const content = contentJson as SiteContent
const allPages = [...content.pages, ...supplementalPages]

function RoutedPage() {
  const { slug = '' } = useParams()
  const decodedSlug = decodeURIComponent(slug)
  if (decodedSlug === 'الرئيسية') return <HomePage articles={content.articles} />
  const page = allPages.find((item) => item.slug === decodedSlug)
  const article = content.articles.find((item) => item.slug === decodedSlug)

  if (page) return <ContentPage page={page} articles={content.articles} />
  if (article) return <ArticlePage article={article} />
  return <NotFoundPage />
}

function DocumentTitle() {
  const location = useLocation()

  useEffect(() => {
    const slug = decodeURIComponent(location.pathname.replace(/^\//, ''))
    const item = [...allPages, ...content.articles].find((entry) => entry.slug === slug)
    document.title = item ? `${item.title} | البيت المحمدي` : 'البيت المحمدي'
  }, [location.pathname])

  return null
}

function PageRoutes() {
  const location = useLocation()

  return (
    <Routes key={location.pathname}>
      <Route path="/" element={<HomePage articles={content.articles} />} />
      <Route path="/category/المجالس-المحمدية" element={<CouncilsArchivePage />} />
      <Route path="/مقالات-وتساؤلات-صوفية" element={<Navigate to="/مقالات-وتساؤلات-صوفية-1" replace />} />
      <Route path="/:slug" element={<RoutedPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <DocumentTitle />
      <Header />
      <PageRoutes />
      <Footer />
    </BrowserRouter>
  )
}
